import { request } from "@umijs/max";

export async function login(body: API.LoginParams) {
  return request<API.LoginResult>("/app-api/auth/login", {
    method: "POST",
    data: body,
  });
}

export async function getCurrentUser() {
  return request<API.CurrentUser>("/app-api/auth/me", {
    skipErrorHandler: true,
  });
}

export async function logout() {
  return request("/app-api/auth/logout", { method: "POST" });
}

export async function register(body: {
  username: string;
  password: string;
  displayName?: string;
}) {
  return request<API.LoginResult>("/app-api/auth/register", {
    method: "POST",
    data: body,
  });
}

export async function changeInitialPassword(body: {
  oldPassword: string;
  newPassword: string;
}) {
  return request("/app-api/auth/change-initial-password", {
    method: "POST",
    data: body,
  });
}

export async function getBootstrapData() {
  return request<API.BootstrapData>("/app-api/bootstrap/user-web", {
    skipErrorHandler: true,
  });
}

export async function getSubscription() {
  return request<API.Subscription>("/app-api/subscription/current", {
    skipErrorHandler: true,
  });
}
